import * as React from 'react';
import { DndProvider, useDrag, useDrop, createDndContext } from 'react-dnd';
import { NiTable } from './index';
import { TableProps } from 'antd/lib/table';
import { HTML5Backend } from 'react-dnd-html5-backend';
import * as update from 'immutability-helper';
import './dragable-table.less';

const { useState, useCallback, useRef, useEffect } = React;
const RNDContext = createDndContext(HTML5Backend);

const type = 'DragableBodyRow';

const DragableBodyRow = ({ index, moveRow, className, style, ...restProps }: any) => {
  const ref = React.useRef();
  const [{ isOver, dropClassName }, drop] = useDrop({
    accept: type,
    collect: (monitor: any) => {
      const { index: dragIndex } = monitor.getItem() || {};
      if (dragIndex === index) {
        return {};
      }
      return {
        isOver: monitor.isOver(),
        dropClassName: dragIndex < index ? ' drop-over-downward' : ' drop-over-upward'
      };
    },
    drop: (item: any) => {
      moveRow(item.index, index);
    }
  });
  const [, drag] = useDrag({
    item: { type, index },
    collect: monitor => ({
      isDragging: monitor.isDragging()
    })
  });
  drop(drag(ref));
  return (
    <tr
      ref={ref}
      className={`${className}${isOver ? dropClassName : ''}`}
      style={{ cursor: 'move', ...style }}
      {...restProps}
    />
  );
};

export type DragableTableProps<RecordType> = TableProps<RecordType> & {
  disabledOrderChange?: boolean;
  onOrderChange?: (data: RecordType[], dragRow: RecordType) => void
};

export const NiDragableTable = (props: DragableTableProps<any>) => {
  const [data, setData] = useState(props.dataSource);
  useEffect(() => {
    setData(props.dataSource);
  }, [props.dataSource]);

  const components = {
    body: {
      row: DragableBodyRow
    }
  };

  const moveRow = useCallback(
    (dragIndex: number, hoverIndex: number) => {

      const dragRow = data && data[dragIndex];

      const nextData = update(data, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, dragRow]
        ]
      });

      if (props.onOrderChange) {
        props.onOrderChange(nextData || [], dragRow);
      }
    },
    [data]
  );

  const manager: any = useRef(RNDContext);
  const table = <NiTable
    components={!props.disabledOrderChange && components || undefined}
    {...props}
    onRow={(data: {}, index?: number) => ({
      index,
      moveRow: !props.disabledOrderChange && moveRow || undefined,
      ...(props.onRow && props.onRow(data, index))
    })}
    className={`${props.className} ${!props.disabledOrderChange && 'ni-dragable-table'}`}
    dataSource={data}
  />;


  return (props.disabledOrderChange
    ? table
    : <DndProvider manager={manager.current.dragDropManager} >
      {table}
    </DndProvider>
  );
};
